import { IEsignatureSettings } from "models/IESignature";

export const BlankESignatureSettings: IEsignatureSettings = {
    isEnabled: false,
    isProduction: false,
    reportSettings: [
        {
            reportName: "",
            reportID: "",
            anchorTag: "",
            units: "",
            xOffset: 0,
            yOffset: 0
        }
    ]
}